export default __webpack_public_path__ + "static/media/logo_diy.8c96355f.png";